import React from 'react';
import { apiClient } from './ApiClient';

export const CrudService = (entity: any) => {

  const getItems = async (inputData: any) => {
    let apiOptions: any = {
      url: `${entity}/query`,
      method: 'post',
      data: inputData
    };
    let result = await apiClient.doAction(apiOptions);
    return result;
  }

  const getItemById = async (inputData: any) => {
    let apiOptions: any = {
      url: `${entity}/${inputData._id}`,
      method: 'get',
      data: { data: inputData._id }
    };
    let result = await apiClient.doAction(apiOptions);
    return result;
  }

  const addItem = async (inputData: any) => {
    let apiOptions: any = {
      url: `${entity}`,
      method: 'post',
      data: inputData
    };
    let result = await apiClient.doAction(apiOptions);
    return result;
  }

  const updateItem = async (inputData: any) => {
    let apiOptions: any = {
      url: `${entity}/${inputData._id}`,
      method: 'put',
      data: inputData
    };
    let result = await apiClient.doAction(apiOptions);
    return result;
  }

  const deleteItem = async (inputData: any) => {
    let apiOptions: any = {
      url: `${entity}/${inputData._id}`,
      method: 'delete'
    };
    let result = await apiClient.doAction(apiOptions);
    return result;
  }

  const getLookups = async (inputData: any) => {
    let apiOptions: any = {
      url: `Options/GetLookupOptions`,
      method: 'post',
      data: inputData
    };
    let result = await apiClient.doAction(apiOptions);
    return result;
  }

  const downloadFile = async (inputData: any) => {
    let apiOptions: any = {
      url: inputData.url,
      method: inputData.method,
      fileName: inputData.fileName
    };
    let result = await apiClient.doDownload(apiOptions);
    return result;
  }

  return { getItems, getItemById, addItem, updateItem, deleteItem, getLookups, downloadFile };
}